/* shop/components/Summary.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	component_subscribe,
	destroy_each,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	noop,
	safe_not_equal,
	set_data_dev,
	space,
	text,
	validate_each_argument,
	validate_slots,
	validate_store
} from "svelte/internal";

import basketStore, {
	basketItemsCount,
	basketPrice,
	basketDiscount
} from "./../basketStore";

import orderStore from "./../orderStore";
const file = "shop/components/Summary.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

// (16:0) {#if $basketItemsCount > 0}
function create_if_block_7(ctx) {
	let div;
	let table;
	let thead;
	let tr0;
	let th0;
	let t1;
	let th1;
	let t3;
	let th2;
	let t5;
	let th3;
	let t7;
	let th4;
	let t9;
	let tbody;
	let t10;
	let tfoot;
	let t11;
	let tr1;
	let td0;
	let t12;
	let t13_value = /*$orderStore*/ ctx[3].delivery_title + "";
	let t13;
	let t14;
	let t15;
	let td1;
	let t16;
	let td2;
	let t17_value = /*$orderStore*/ ctx[3].price_delivery.toLocaleString() + "";
	let t17;
	let t18;
	let t19;
	let td3;
	let t20;
	let td4;
	let t21_value = /*$orderStore*/ ctx[3].price_delivery.toLocaleString() + "";
	let t21;
	let t22;
	let t23;
	let tr2;
	let td5;
	let t24;
	let t25_value = /*$orderStore*/ ctx[3].payment_title + "";
	let t25;
	let t26;
	let td6;
	let t27;
	let td7;
	let t28_value = /*$orderStore*/ ctx[3].price_payment.toLocaleString() + "";
	let t28;
	let t29;
	let t30;
	let td8;
	let t31;
	let td9;
	let t32_value = /*$orderStore*/ ctx[3].price_payment.toLocaleString() + "";
	let t32;
	let t33;
	let t34;
	let tr3;
	let td10;
	let t36;
	let td11;
	let t37;
	let td12;
	let t38;
	let td13;
	let t39;
	let td14;
	let t40_value = (/*$basketPrice*/ ctx[4] + /*$orderStore*/ ctx[3].price_delivery + /*$orderStore*/ ctx[3].price_payment).toLocaleString() + "";
	let t40;
	let t41;
	let each_value = /*$basketStore*/ ctx[1].items;
	validate_each_argument(each_value);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block0 = /*$basketDiscount*/ ctx[2] > 0 && create_if_block_9(ctx);
	let if_block1 = /*$orderStore*/ ctx[3].delivery_data?.subtitleHTML && create_if_block_8(ctx);

	const block = {
		c: function create() {
			div = element("div");
			table = element("table");
			thead = element("thead");
			tr0 = element("tr");
			th0 = element("th");
			th0.textContent = "Položka";
			t1 = space();
			th1 = element("th");
			th1.textContent = "Typ";
			t3 = space();
			th2 = element("th");
			th2.textContent = "Cena";
			t5 = space();
			th3 = element("th");
			th3.textContent = "Počet";
			t7 = space();
			th4 = element("th");
			th4.textContent = "Cena celkem";
			t9 = space();
			tbody = element("tbody");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t10 = space();
			tfoot = element("tfoot");
			if (if_block0) if_block0.c();
			t11 = space();
			tr1 = element("tr");
			td0 = element("td");
			t12 = text("Doprava: ");
			t13 = text(t13_value);
			t14 = space();
			if (if_block1) if_block1.c();
			t15 = space();
			td1 = element("td");
			t16 = space();
			td2 = element("td");
			t17 = text(t17_value);
			t18 = text(" Kč");
			t19 = space();
			td3 = element("td");
			t20 = space();
			td4 = element("td");
			t21 = text(t21_value);
			t22 = text(" Kč");
			t23 = space();
			tr2 = element("tr");
			td5 = element("td");
			t24 = text("Platba: ");
			t25 = text(t25_value);
			t26 = space();
			td6 = element("td");
			t27 = space();
			td7 = element("td");
			t28 = text(t28_value);
			t29 = text(" Kč");
			t30 = space();
			td8 = element("td");
			t31 = space();
			td9 = element("td");
			t32 = text(t32_value);
			t33 = text(" Kč");
			t34 = space();
			tr3 = element("tr");
			td10 = element("td");
			td10.textContent = "Celkem";
			t36 = space();
			td11 = element("td");
			t37 = space();
			td12 = element("td");
			t38 = space();
			td13 = element("td");
			t39 = space();
			td14 = element("td");
			t40 = text(t40_value);
			t41 = text(" Kč");
			add_location(th0, file, 20, 16, 495);
			add_location(th1, file, 21, 16, 528);
			add_location(th2, file, 22, 16, 557);
			add_location(th3, file, 23, 16, 587);
			add_location(th4, file, 24, 16, 618);
			add_location(tr0, file, 19, 12, 474);
			add_location(thead, file, 18, 8, 454);
			add_location(tbody, file, 27, 8, 682);
			add_location(td0, file, 62, 16, 1788);
			add_location(td1, file, 70, 16, 2117);
			add_location(td2, file, 71, 16, 2143);
			add_location(td3, file, 72, 16, 2217);
			add_location(td4, file, 73, 16, 2243);
			add_location(tr1, file, 61, 12, 1767);
			add_location(td5, file, 78, 16, 2381);
			add_location(td6, file, 79, 16, 2442);
			add_location(td7, file, 80, 16, 2468);
			add_location(td8, file, 81, 16, 2541);
			add_location(td9, file, 82, 16, 2567);
			add_location(tr2, file, 77, 12, 2360);
			add_location(td10, file, 87, 16, 2708);
			add_location(td11, file, 88, 16, 2740);
			add_location(td12, file, 89, 16, 2766);
			add_location(td13, file, 90, 16, 2792);
			add_location(td14, file, 91, 16, 2818);
			add_location(tr3, file, 86, 12, 2687);
			add_location(tfoot, file, 47, 8, 1323);
			attr_dev(table, "class", "uk-table basketTable ");
			add_location(table, file, 17, 4, 407);
			attr_dev(div, "class", "uk-overflow-auto");
			add_location(div, file, 16, 0, 372);
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			append_dev(div, table);
			append_dev(table, thead);
			append_dev(thead, tr0);
			append_dev(tr0, th0);
			append_dev(tr0, t1);
			append_dev(tr0, th1);
			append_dev(tr0, t3);
			append_dev(tr0, th2);
			append_dev(tr0, t5);
			append_dev(tr0, th3);
			append_dev(tr0, t7);
			append_dev(tr0, th4);
			append_dev(table, t9);
			append_dev(table, tbody);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(tbody, null);
				}
			}

			append_dev(table, t10);
			append_dev(table, tfoot);
			if (if_block0) if_block0.m(tfoot, null);
			append_dev(tfoot, t11);
			append_dev(tfoot, tr1);
			append_dev(tr1, td0);
			append_dev(td0, t12);
			append_dev(td0, t13);
			append_dev(td0, t14);
			if (if_block1) if_block1.m(td0, null);
			append_dev(tr1, t15);
			append_dev(tr1, td1);
			append_dev(tr1, t16);
			append_dev(tr1, td2);
			append_dev(td2, t17);
			append_dev(td2, t18);
			append_dev(tr1, t19);
			append_dev(tr1, td3);
			append_dev(tr1, t20);
			append_dev(tr1, td4);
			append_dev(td4, t21);
			append_dev(td4, t22);
			append_dev(tfoot, t23);
			append_dev(tfoot, tr2);
			append_dev(tr2, td5);
			append_dev(td5, t24);
			append_dev(td5, t25);
			append_dev(tr2, t26);
			append_dev(tr2, td6);
			append_dev(tr2, t27);
			append_dev(tr2, td7);
			append_dev(td7, t28);
			append_dev(td7, t29);
			append_dev(tr2, t30);
			append_dev(tr2, td8);
			append_dev(tr2, t31);
			append_dev(tr2, td9);
			append_dev(td9, t32);
			append_dev(td9, t33);
			append_dev(tfoot, t34);
			append_dev(tfoot, tr3);
			append_dev(tr3, td10);
			append_dev(tr3, t36);
			append_dev(tr3, td11);
			append_dev(tr3, t37);
			append_dev(tr3, td12);
			append_dev(tr3, t38);
			append_dev(tr3, td13);
			append_dev(tr3, t39);
			append_dev(tr3, td14);
			append_dev(td14, t40);
			append_dev(td14, t41);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$basketStore*/ 2) {
				each_value = /*$basketStore*/ ctx[1].items;
				validate_each_argument(each_value);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(tbody, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (/*$basketDiscount*/ ctx[2] > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_9(ctx);
					if_block0.c();
					if_block0.m(tfoot, t11);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*$orderStore*/ 8 && t13_value !== (t13_value = /*$orderStore*/ ctx[3].delivery_title + "")) set_data_dev(t13, t13_value);

			if (/*$orderStore*/ ctx[3].delivery_data?.subtitleHTML) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_8(ctx);
					if_block1.c();
					if_block1.m(td0, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*$orderStore*/ 8 && t17_value !== (t17_value = /*$orderStore*/ ctx[3].price_delivery.toLocaleString() + "")) set_data_dev(t17, t17_value);
			if (dirty & /*$orderStore*/ 8 && t21_value !== (t21_value = /*$orderStore*/ ctx[3].price_delivery.toLocaleString() + "")) set_data_dev(t21, t21_value);
			if (dirty & /*$orderStore*/ 8 && t25_value !== (t25_value = /*$orderStore*/ ctx[3].payment_title + "")) set_data_dev(t25, t25_value);
			if (dirty & /*$orderStore*/ 8 && t28_value !== (t28_value = /*$orderStore*/ ctx[3].price_payment.toLocaleString() + "")) set_data_dev(t28, t28_value);
			if (dirty & /*$orderStore*/ 8 && t32_value !== (t32_value = /*$orderStore*/ ctx[3].price_payment.toLocaleString() + "")) set_data_dev(t32, t32_value);
			if (dirty & /*$basketPrice, $orderStore*/ 24 && t40_value !== (t40_value = (/*$basketPrice*/ ctx[4] + /*$orderStore*/ ctx[3].price_delivery + /*$orderStore*/ ctx[3].price_payment).toLocaleString() + "")) set_data_dev(t40, t40_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
			destroy_each(each_blocks, detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_7.name,
		type: "if",
		source: "(16:0) {#if $basketItemsCount > 0}",
		ctx
	});

	return block;
}

// (33:24) {#if item.description}
function create_if_block_10(ctx) {
	let br;
	let t_value = /*item*/ ctx[5].description + "";
	let t;

	const block = {
		c: function create() {
			br = element("br");
			t = text(t_value);
			add_location(br, file, 33, 28, 912);
		},
		m: function mount(target, anchor) {
			insert_dev(target, br, anchor);
			insert_dev(target, t, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$basketStore*/ 2 && t_value !== (t_value = /*item*/ ctx[5].description + "")) set_data_dev(t, t_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(br);
			if (detaching) detach_dev(t);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_10.name,
		type: "if",
		source: "(33:24) {#if item.description}",
		ctx
	});

	return block;
}

// (29:12) {#each $basketStore.items as item}
function create_each_block(ctx) {
	let tr;
	let td0;
	let strong;
	let t0_value = /*item*/ ctx[5].title + "";
	let t0;
	let t1;
	let t2;
	let td1;

	let t3_value = (/*item*/ ctx[5].book_type == 'PRINT'
	? 'tištěná'
	: 'ekniha') + "";

	let t3;
	let t4;
	let td2;
	let t5_value = /*item*/ ctx[5].unit_price.toLocaleString() + "";
	let t5;
	let t6;
	let t7;
	let td3;
	let t8_value = /*item*/ ctx[5].quantity + "";
	let t8;
	let t9;
	let td4;
	let t10_value = /*item*/ ctx[5].full_price.toLocaleString() + "";
	let t10;
	let t11;
	let t12;
	let if_block = /*item*/ ctx[5].description && create_if_block_10(ctx);

	const block = {
		c: function create() {
			tr = element("tr");
			td0 = element("td");
			strong = element("strong");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			t2 = space();
			td1 = element("td");
			t3 = text(t3_value);
			t4 = space();
			td2 = element("td");
			t5 = text(t5_value);
			t6 = text(" Kč");
			t7 = space();
			td3 = element("td");
			t8 = text(t8_value);
			t9 = space();
			td4 = element("td");
			t10 = text(t10_value);
			t11 = text(" Kč");
			t12 = space();
			add_location(strong, file, 31, 24, 807);
			add_location(td0, file, 30, 20, 778);
			add_location(td1, file, 37, 20, 1014);
			add_location(td2, file, 39, 20, 1095);
			add_location(td3, file, 41, 20, 1163);
			add_location(td4, file, 43, 20, 1209);
			add_location(tr, file, 29, 16, 753);
		},
		m: function mount(target, anchor) {
			insert_dev(target, tr, anchor);
			append_dev(tr, td0);
			append_dev(td0, strong);
			append_dev(strong, t0);
			append_dev(td0, t1);
			if (if_block) if_block.m(td0, null);
			append_dev(tr, t2);
			append_dev(tr, td1);
			append_dev(td1, t3);
			append_dev(tr, t4);
			append_dev(tr, td2);
			append_dev(td2, t5);
			append_dev(td2, t6);
			append_dev(tr, t7);
			append_dev(tr, td3);
			append_dev(td3, t8);
			append_dev(tr, t9);
			append_dev(tr, td4);
			append_dev(td4, t10);
			append_dev(td4, t11);
			append_dev(tr, t12);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$basketStore*/ 2 && t0_value !== (t0_value = /*item*/ ctx[5].title + "")) set_data_dev(t0, t0_value);

			if (/*item*/ ctx[5].description) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_10(ctx);
					if_block.c();
					if_block.m(td0, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*$basketStore*/ 2 && t3_value !== (t3_value = (/*item*/ ctx[5].book_type == 'PRINT'
			? 'tištěná'
			: 'ekniha') + "")) set_data_dev(t3, t3_value);

			if (dirty & /*$basketStore*/ 2 && t5_value !== (t5_value = /*item*/ ctx[5].unit_price.toLocaleString() + "")) set_data_dev(t5, t5_value);
			if (dirty & /*$basketStore*/ 2 && t8_value !== (t8_value = /*item*/ ctx[5].quantity + "")) set_data_dev(t8, t8_value);
			if (dirty & /*$basketStore*/ 2 && t10_value !== (t10_value = /*item*/ ctx[5].full_price.toLocaleString() + "")) set_data_dev(t10, t10_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(tr);
			if (if_block) if_block.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_each_block.name,
		type: "each",
		source: "(29:12) {#each $basketStore.items as item}",
		ctx
	});

	return block;
}

// (50:12) {#if $basketDiscount > 0}
function create_if_block_9(ctx) {
	let tr;
	let td0;
	let strong;
	let t1;
	let td1;
	let t2;
	let td2;
	let t3;
	let t4_value = /*$basketDiscount*/ ctx[2].toLocaleString() + "";
	let t4;
	let t5;
	let t6;
	let td3;
	let t7;
	let td4;
	let t8;
	let t9_value = /*$basketDiscount*/ ctx[2].toLocaleString() + "";
	let t9;
	let t10;

	const block = {
		c: function create() {
			tr = element("tr");
			td0 = element("td");
			strong = element("strong");
			strong.textContent = "Sleva";
			t1 = space();
			td1 = element("td");
			t2 = space();
			td2 = element("td");
			t3 = text("-");
			t4 = text(t4_value);
			t5 = text(" Kč");
			t6 = space();
			td3 = element("td");
			t7 = space();
			td4 = element("td");
			t8 = text("-");
			t9 = text(t9_value);
			t10 = text(" Kč");
			add_location(strong, file, 52, 20, 1465);
			add_location(td0, file, 51, 16, 1440);
			add_location(td1, file, 54, 16, 1526);
			add_location(td2, file, 55, 16, 1552);
			add_location(td3, file, 56, 16, 1616);
			add_location(td4, file, 57, 16, 1642);
			add_location(tr, file, 50, 12, 1419);
		},
		m: function mount(target, anchor) {
			insert_dev(target, tr, anchor);
			append_dev(tr, td0);
			append_dev(td0, strong);
			append_dev(tr, t1);
			append_dev(tr, td1);
			append_dev(tr, t2);
			append_dev(tr, td2);
			append_dev(td2, t3);
			append_dev(td2, t4);
			append_dev(td2, t5);
			append_dev(tr, t6);
			append_dev(tr, td3);
			append_dev(tr, t7);
			append_dev(tr, td4);
			append_dev(td4, t8);
			append_dev(td4, t9);
			append_dev(td4, t10);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$basketDiscount*/ 4 && t4_value !== (t4_value = /*$basketDiscount*/ ctx[2].toLocaleString() + "")) set_data_dev(t4, t4_value);
			if (dirty & /*$basketDiscount*/ 4 && t9_value !== (t9_value = /*$basketDiscount*/ ctx[2].toLocaleString() + "")) set_data_dev(t9, t9_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(tr);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_9.name,
		type: "if",
		source: "(50:12) {#if $basketDiscount > 0}",
		ctx
	});

	return block;
}

// (65:20) {#if $orderStore.delivery_data?.subtitleHTML}
function create_if_block_8(ctx) {
	let div;
	let raw_value = /*$orderStore*/ ctx[3].delivery_data.subtitleHTML + "";

	const block = {
		c: function create() {
			div = element("div");
			add_location(div, file, 65, 24, 1941);
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			div.innerHTML = raw_value;
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && raw_value !== (raw_value = /*$orderStore*/ ctx[3].delivery_data.subtitleHTML + "")) div.innerHTML = raw_value;;
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_8.name,
		type: "if",
		source: "(65:20) {#if $orderStore.delivery_data?.subtitleHTML}",
		ctx
	});

	return block;
}

// (106:8) {#if $orderStore.customer_type == 'PERSONAL'}
function create_if_block_6(ctx) {
	let t;

	const block = {
		c: function create() {
			t = text("Soukromá osoba");
		},
		m: function mount(target, anchor) {
			insert_dev(target, t, anchor);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(t);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_6.name,
		type: "if",
		source: "(106:8) {#if $orderStore.customer_type == 'PERSONAL'}",
		ctx
	});

	return block;
}

// (109:8) {#if $orderStore.customer_type == 'COMPANY'}
function create_if_block_5(ctx) {
	let t;

	const block = {
		c: function create() {
			t = text("Firma");
		},
		m: function mount(target, anchor) {
			insert_dev(target, t, anchor);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(t);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_5.name,
		type: "if",
		source: "(109:8) {#if $orderStore.customer_type == 'COMPANY'}",
		ctx
	});

	return block;
}

// (115:13) {#if $orderStore.customer_type == 'COMPANY'}
function create_if_block_4(ctx) {
	let t0;
	let strong0;
	let t1_value = (/*$orderStore*/ ctx[3].company_name != undefined && /*$orderStore*/ ctx[3].company_name) + "";
	let t1;
	let t2;
	let br;
	let t3;
	let strong1;
	let t4_value = (/*$orderStore*/ ctx[3].company_id != undefined && /*$orderStore*/ ctx[3].company_id) + "";
	let t4;

	const block = {
		c: function create() {
			t0 = text("Název společnosti ");
			strong0 = element("strong");
			t1 = text(t1_value);
			t2 = space();
			br = element("br");
			t3 = text("\n            IČ: ");
			strong1 = element("strong");
			t4 = text(t4_value);
			add_location(strong0, file, 115, 34, 3515);
			add_location(br, file, 116, 12, 3612);
			add_location(strong1, file, 117, 16, 3635);
		},
		m: function mount(target, anchor) {
			insert_dev(target, t0, anchor);
			insert_dev(target, strong0, anchor);
			append_dev(strong0, t1);
			insert_dev(target, t2, anchor);
			insert_dev(target, br, anchor);
			insert_dev(target, t3, anchor);
			insert_dev(target, strong1, anchor);
			append_dev(strong1, t4);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t1_value !== (t1_value = (/*$orderStore*/ ctx[3].company_name != undefined && /*$orderStore*/ ctx[3].company_name) + "")) set_data_dev(t1, t1_value);
			if (dirty & /*$orderStore*/ 8 && t4_value !== (t4_value = (/*$orderStore*/ ctx[3].company_id != undefined && /*$orderStore*/ ctx[3].company_id) + "")) set_data_dev(t4, t4_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(strong0);
			if (detaching) detach_dev(t2);
			if (detaching) detach_dev(br);
			if (detaching) detach_dev(t3);
			if (detaching) detach_dev(strong1);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_4.name,
		type: "if",
		source: "(115:13) {#if $orderStore.customer_type == 'COMPANY'}",
		ctx
	});

	return block;
}

// (134:12) {#if $orderStore.delivery_address_street}
function create_if_block_3(ctx) {
	let t0;
	let br0;
	let t1;
	let strong;
	let t2_value = /*$orderStore*/ ctx[3].delivery_address_street + "";
	let t2;
	let br1;

	const block = {
		c: function create() {
			t0 = text("Doručovací adresa:");
			br0 = element("br");
			t1 = space();
			strong = element("strong");
			t2 = text(t2_value);
			br1 = element("br");
			add_location(br0, file, 134, 34, 4560);
			add_location(strong, file, 135, 16, 4583);
			add_location(br1, file, 135, 70, 4637);
		},
		m: function mount(target, anchor) {
			insert_dev(target, t0, anchor);
			insert_dev(target, br0, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, strong, anchor);
			append_dev(strong, t2);
			insert_dev(target, br1, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t2_value !== (t2_value = /*$orderStore*/ ctx[3].delivery_address_street + "")) set_data_dev(t2, t2_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(br0);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(strong);
			if (detaching) detach_dev(br1);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_3.name,
		type: "if",
		source: "(134:12) {#if $orderStore.delivery_address_street}",
		ctx
	});

	return block;
}

// (139:12) {#if $orderStore.delivery_address_city}
function create_if_block_2(ctx) {
	let t0;
	let strong;
	let t1_value = /*$orderStore*/ ctx[3].delivery_address_city + "";
	let t1;
	let t2;

	const block = {
		c: function create() {
			t0 = text("město: ");
			strong = element("strong");
			t1 = text(t1_value);
			t2 = text(",");
			add_location(strong, file, 139, 23, 4738);
		},
		m: function mount(target, anchor) {
			insert_dev(target, t0, anchor);
			insert_dev(target, strong, anchor);
			append_dev(strong, t1);
			insert_dev(target, t2, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t1_value !== (t1_value = /*$orderStore*/ ctx[3].delivery_address_city + "")) set_data_dev(t1, t1_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(strong);
			if (detaching) detach_dev(t2);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_2.name,
		type: "if",
		source: "(139:12) {#if $orderStore.delivery_address_city}",
		ctx
	});

	return block;
}

// (143:12) {#if $orderStore.delivery_address_zip}
function create_if_block_1(ctx) {
	let t0_value = /*$orderStore*/ ctx[3].delivery_address_zip + "";
	let t0;
	let t1;
	let br;

	const block = {
		c: function create() {
			t0 = text(t0_value);
			t1 = space();
			br = element("br");
			add_location(br, file, 144, 16, 4929);
		},
		m: function mount(target, anchor) {
			insert_dev(target, t0, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, br, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t0_value !== (t0_value = /*$orderStore*/ ctx[3].delivery_address_zip + "")) set_data_dev(t0, t0_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(br);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(143:12) {#if $orderStore.delivery_address_zip}",
		ctx
	});

	return block;
}

// (148:12) {#if $orderStore.order_description}
function create_if_block(ctx) {
	let t0;
	let br;
	let t1_value = /*$orderStore*/ ctx[3].order_description + "";
	let t1;

	const block = {
		c: function create() {
			t0 = text("Poznámka:");
			br = element("br");
			t1 = text(t1_value);
			add_location(br, file, 148, 25, 5028);
		},
		m: function mount(target, anchor) {
			insert_dev(target, t0, anchor);
			insert_dev(target, br, anchor);
			insert_dev(target, t1, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t1_value !== (t1_value = /*$orderStore*/ ctx[3].order_description + "")) set_data_dev(t1, t1_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(br);
			if (detaching) detach_dev(t1);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(148:12) {#if $orderStore.order_description}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let h1;
	let t1;
	let div0;
	let t3;
	let t4;
	let div5;
	let div1;
	let t5;
	let t6;
	let div4;
	let div2;
	let t7;
	let strong0;
	let t8_value = (/*$orderStore*/ ctx[3].name_and_surname != undefined && /*$orderStore*/ ctx[3].name_and_surname) + "";
	let t8;
	let t9;
	let br0;
	let t10;
	let strong1;
	let t11_value = (/*$orderStore*/ ctx[3].email != undefined && /*$orderStore*/ ctx[3].email) + "";
	let t11;
	let t12;
	let br1;
	let t13;
	let strong2;
	let t14_value = (/*$orderStore*/ ctx[3].phone != undefined && /*$orderStore*/ ctx[3].phone) + "";
	let t14;
	let t15;
	let div3;
	let t16;
	let strong3;
	let t17_value = (/*$orderStore*/ ctx[3].address_street != undefined && /*$orderStore*/ ctx[3].address_street) + "";
	let t17;
	let t18;
	let br2;
	let t19;
	let strong4;
	let t20_value = (/*$orderStore*/ ctx[3].address_city != undefined && /*$orderStore*/ ctx[3].address_city) + "";
	let t20;
	let t21;
	let strong5;
	let t22_value = (/*$orderStore*/ ctx[3].address_zip != undefined && /*$orderStore*/ ctx[3].address_zip) + "";
	let t22;
	let t23;
	let br3;
	let t24;
	let t25;
	let t26;
	let t27;
	let if_block0 = /*$basketItemsCount*/ ctx[0] > 0 && create_if_block_7(ctx);
	let if_block1 = /*$orderStore*/ ctx[3].customer_type == 'PERSONAL' && create_if_block_6(ctx);
	let if_block2 = /*$orderStore*/ ctx[3].customer_type == 'COMPANY' && create_if_block_5(ctx);
	let if_block3 = /*$orderStore*/ ctx[3].customer_type == 'COMPANY' && create_if_block_4(ctx);
	let if_block4 = /*$orderStore*/ ctx[3].delivery_address_street && create_if_block_3(ctx);
	let if_block5 = /*$orderStore*/ ctx[3].delivery_address_city && create_if_block_2(ctx);
	let if_block6 = /*$orderStore*/ ctx[3].delivery_address_zip && create_if_block_1(ctx);
	let if_block7 = /*$orderStore*/ ctx[3].order_description && create_if_block(ctx);

	const block = {
		c: function create() {
			h1 = element("h1");
			h1.textContent = "Shrnutí";
			t1 = space();
			div0 = element("div");
			div0.textContent = " ";
			t3 = space();
			if (if_block0) if_block0.c();
			t4 = space();
			div5 = element("div");
			div1 = element("div");
			if (if_block1) if_block1.c();
			t5 = space();
			if (if_block2) if_block2.c();
			t6 = space();
			div4 = element("div");
			div2 = element("div");
			if (if_block3) if_block3.c();
			t7 = text("\n\n            Jméno a příjmení: ");
			strong0 = element("strong");
			t8 = text(t8_value);
			t9 = space();
			br0 = element("br");
			t10 = text("\n            email ");
			strong1 = element("strong");
			t11 = text(t11_value);
			t12 = space();
			br1 = element("br");
			t13 = text("\n            tel.: ");
			strong2 = element("strong");
			t14 = text(t14_value);
			t15 = space();
			div3 = element("div");
			t16 = text("ulice: ");
			strong3 = element("strong");
			t17 = text(t17_value);
			t18 = space();
			br2 = element("br");
			t19 = text("\n            město: ");
			strong4 = element("strong");
			t20 = text(t20_value);
			t21 = text(",\n            ");
			strong5 = element("strong");
			t22 = text(t22_value);
			t23 = space();
			br3 = element("br");
			t24 = space();
			if (if_block4) if_block4.c();
			t25 = space();
			if (if_block5) if_block5.c();
			t26 = space();
			if (if_block6) if_block6.c();
			t27 = space();
			if (if_block7) if_block7.c();
			add_location(h1, file, 12, 0, 255);
			attr_dev(div0, "class", "basketInfoEmpty");
			add_location(div0, file, 13, 0, 272);
			attr_dev(div1, "class", "basketOrderPadd");
			add_location(div1, file, 104, 4, 3116);
			add_location(strong0, file, 120, 30, 3761);
			add_location(br0, file, 121, 12, 3866);
			add_location(strong1, file, 122, 18, 3891);
			add_location(br1, file, 123, 12, 3974);
			add_location(strong2, file, 124, 18, 3999);
			attr_dev(div2, "class", "basketOrderPerson");
			add_location(div2, file, 113, 8, 3391);
			add_location(strong3, file, 127, 18, 4144);
			add_location(br2, file, 128, 12, 4245);
			add_location(strong4, file, 129, 19, 4271);
			add_location(strong5, file, 130, 12, 4369);
			add_location(br3, file, 131, 12, 4464);
			attr_dev(div3, "class", "basketOrderPayment");
			add_location(div3, file, 126, 8, 4093);
			attr_dev(div4, "class", "basketOrder basketOrderPadd");
			add_location(div4, file, 112, 4, 3341);
			add_location(div5, file, 103, 0, 3106);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, h1, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, div0, anchor);
			insert_dev(target, t3, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert_dev(target, t4, anchor);
			insert_dev(target, div5, anchor);
			append_dev(div5, div1);
			if (if_block1) if_block1.m(div1, null);
			append_dev(div1, t5);
			if (if_block2) if_block2.m(div1, null);
			append_dev(div5, t6);
			append_dev(div5, div4);
			append_dev(div4, div2);
			if (if_block3) if_block3.m(div2, null);
			append_dev(div2, t7);
			append_dev(div2, strong0);
			append_dev(strong0, t8);
			append_dev(div2, t9);
			append_dev(div2, br0);
			append_dev(div2, t10);
			append_dev(div2, strong1);
			append_dev(strong1, t11);
			append_dev(div2, t12);
			append_dev(div2, br1);
			append_dev(div2, t13);
			append_dev(div2, strong2);
			append_dev(strong2, t14);
			append_dev(div4, t15);
			append_dev(div4, div3);
			append_dev(div3, t16);
			append_dev(div3, strong3);
			append_dev(strong3, t17);
			append_dev(div3, t18);
			append_dev(div3, br2);
			append_dev(div3, t19);
			append_dev(div3, strong4);
			append_dev(strong4, t20);
			append_dev(div3, t21);
			append_dev(div3, strong5);
			append_dev(strong5, t22);
			append_dev(div3, t23);
			append_dev(div3, br3);
			append_dev(div3, t24);
			if (if_block4) if_block4.m(div3, null);
			append_dev(div3, t25);
			if (if_block5) if_block5.m(div3, null);
			append_dev(div3, t26);
			if (if_block6) if_block6.m(div3, null);
			append_dev(div3, t27);
			if (if_block7) if_block7.m(div3, null);
		},
		p: function update(ctx, [dirty]) {
			if (/*$basketItemsCount*/ ctx[0] > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_7(ctx);
					if_block0.c();
					if_block0.m(t4.parentNode, t4);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*$orderStore*/ ctx[3].customer_type == 'PERSONAL') {
				if (if_block1) {
					
				} else {
					if_block1 = create_if_block_6(ctx);
					if_block1.c();
					if_block1.m(div1, t5);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*$orderStore*/ ctx[3].customer_type == 'COMPANY') {
				if (if_block2) {
					
				} else {
					if_block2 = create_if_block_5(ctx);
					if_block2.c();
					if_block2.m(div1, null);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (/*$orderStore*/ ctx[3].customer_type == 'COMPANY') {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_4(ctx);
					if_block3.c();
					if_block3.m(div2, t7);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (dirty & /*$orderStore*/ 8 && t8_value !== (t8_value = (/*$orderStore*/ ctx[3].name_and_surname != undefined && /*$orderStore*/ ctx[3].name_and_surname) + "")) set_data_dev(t8, t8_value);
			if (dirty & /*$orderStore*/ 8 && t11_value !== (t11_value = (/*$orderStore*/ ctx[3].email != undefined && /*$orderStore*/ ctx[3].email) + "")) set_data_dev(t11, t11_value);
			if (dirty & /*$orderStore*/ 8 && t14_value !== (t14_value = (/*$orderStore*/ ctx[3].phone != undefined && /*$orderStore*/ ctx[3].phone) + "")) set_data_dev(t14, t14_value);
			if (dirty & /*$orderStore*/ 8 && t17_value !== (t17_value = (/*$orderStore*/ ctx[3].address_street != undefined && /*$orderStore*/ ctx[3].address_street) + "")) set_data_dev(t17, t17_value);
			if (dirty & /*$orderStore*/ 8 && t20_value !== (t20_value = (/*$orderStore*/ ctx[3].address_city != undefined && /*$orderStore*/ ctx[3].address_city) + "")) set_data_dev(t20, t20_value);
			if (dirty & /*$orderStore*/ 8 && t22_value !== (t22_value = (/*$orderStore*/ ctx[3].address_zip != undefined && /*$orderStore*/ ctx[3].address_zip) + "")) set_data_dev(t22, t22_value);

			if (/*$orderStore*/ ctx[3].delivery_address_street) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block_3(ctx);
					if_block4.c();
					if_block4.m(div3, t25);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}

			if (/*$orderStore*/ ctx[3].delivery_address_city) {
				if (if_block5) {
					if_block5.p(ctx, dirty);
				} else {
					if_block5 = create_if_block_2(ctx);
					if_block5.c();
					if_block5.m(div3, t26);
				}
			} else if (if_block5) {
				if_block5.d(1);
				if_block5 = null;
			}

			if (/*$orderStore*/ ctx[3].delivery_address_zip) {
				if (if_block6) {
					if_block6.p(ctx, dirty);
				} else {
					if_block6 = create_if_block_1(ctx);
					if_block6.c();
					if_block6.m(div3, t27);
				}
			} else if (if_block6) {
				if_block6.d(1);
				if_block6 = null;
			}

			if (/*$orderStore*/ ctx[3].order_description) {
				if (if_block7) {
					if_block7.p(ctx, dirty);
				} else {
					if_block7 = create_if_block(ctx);
					if_block7.c();
					if_block7.m(div3, null);
				}
			} else if (if_block7) {
				if_block7.d(1);
				if_block7 = null;
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(h1);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(div0);
			if (detaching) detach_dev(t3);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach_dev(t4);
			if (detaching) detach_dev(div5);
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (if_block4) if_block4.d();
			if (if_block5) if_block5.d();
			if (if_block6) if_block6.d();
			if (if_block7) if_block7.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let $basketItemsCount;
	let $basketStore;
	let $basketDiscount;
	let $orderStore;
	let $basketPrice;
	validate_store(basketItemsCount, 'basketItemsCount');
	component_subscribe($$self, basketItemsCount, $$value => $$invalidate(0, $basketItemsCount = $$value));
	validate_store(basketStore, 'basketStore');
	component_subscribe($$self, basketStore, $$value => $$invalidate(1, $basketStore = $$value));
	validate_store(basketDiscount, 'basketDiscount');
	component_subscribe($$self, basketDiscount, $$value => $$invalidate(2, $basketDiscount = $$value));
	validate_store(orderStore, 'orderStore');
	component_subscribe($$self, orderStore, $$value => $$invalidate(3, $orderStore = $$value));
	validate_store(basketPrice, 'basketPrice');
	component_subscribe($$self, basketPrice, $$value => $$invalidate(4, $basketPrice = $$value));
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('Summary', slots, []);
	const writable_props = [];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<Summary> was created with unknown prop '${key}'`);
	});

	$$self.$capture_state = () => ({
		basketStore,
		basketItemsCount,
		basketPrice,
		basketDiscount,
		orderStore,
		$basketItemsCount,
		$basketStore,
		$basketDiscount,
		$orderStore,
		$basketPrice
	});

	return [$basketItemsCount, $basketStore, $basketDiscount, $orderStore, $basketPrice];
}

class Summary extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, {});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Summary",
			options,
			id: create_fragment.name
		});
	}
}

export default Summary;